<div class="breadcrumbs focus-outline-white">
  @if (selectedService.getOrg()) {
    <div class="crumb">
      <ngx-org-picker class="crumb-title"></ngx-org-picker>
      <menu-button>
        <org-menu [org]="selectedService.getOrg()"></org-menu>
      </menu-button>
    </div>
  }
  @if (selectedService.getAccount()) {
    <div class="crumb">
      <span class="crumb-title">{{selectedService.getAccount().name}}</span>
      <span class="crumb-id">({{selectedService.getAccount().getId()}})</span>
      <menu-button>
        <account-menu [account]="selectedService.getAccount()"></account-menu>
      </menu-button>
    </div>
  }
  @if (selectedService.getGroup() && selectedService.getGroup().isCourse()) {
    <div class="crumb">
      <span class="crumb-title">{{selectedService.getGroup().name}}</span>
      <span class="crumb-id">({{selectedService.getGroup().getId()}})</span>
      <menu-button>
        <folder-menu [folder]="selectedService.getGroup()"></folder-menu>
      </menu-button>
    </div>
  }
</div>

<div class="super-actions">
  <!-- Super admin search -->
  <form (ngSubmit)="openUserSearch(searchValue)">
    <div class="search-bar">
      <div class="input-group" role="search">
        <span class="search-txt" translate="common_search"></span>
        <input
          [attr.aria-label]="'modal-user-search_placeholder-search-user' | translate"
          type="text"
          class="form-control search-input"
          name="user"
          [(ngModel)]="searchValue"
          placeholder="{{'header_placeholder-search-for-users' | translate}}" />
        @if (!searchValue) {
          <span class="input-group-addon"><i class="ficon-search"></i></span>
        }
        @if (searchValue) {
          <span class="input-group-addon search-clear">
            <button type="button" (click)="clearSearch()" [attr.aria-label]="'common_cancel-search' | translate" class="ficon-app-x btn-none"></button>
          </span>
        }
      </div>
    </div>
  </form>
</div>
